//检查不允许出现在IE和不允许出现在微信内置浏览器中，如果出现则跳转到NOIE页面，同时如果此URL在正常浏览器中打开，则会自动返回原页面
export default {
    locationChanged: function () {
        if (
            (navigator.userAgent.indexOf('Trident') > 0 ||
            navigator.userAgent.indexOf('MSIE') > 0 ||
            navigator.userAgent.indexOf('MicroMessenger') > 0)
            && location.href.indexOf("/NOIE")==-1
          ) {
            //this.$router.push('NOIE?ret='+encodeURIComponent(location.href));
            let targetUrl = location.protocol+'//'+location.host+"/#/NOIE?ret="+encodeURIComponent(location.href);
            console.log(targetUrl);
            location.href = targetUrl;
            return true;
        }
        return false;
    },
    locationNextUrl: function(redirect) {
        let target = null;
        let returned = false;
        let queryReturn = location.href.match(/ret=([\w\.%-]+)/);
        if (queryReturn!=null && queryReturn.length==2) {
            target = decodeURIComponent(queryReturn[1]);
            let nextPage = new URL(target);
            if (nextPage.host==location.host && redirect) {
                console.log("jump to "+target);
                location.href = target;
                returned = true;
            }
        }
        return {returned: returned, target: target};
    },
    locationReturned: function() {
        return this.locationNextUrl(true).returned;
    }
}